import type { MinimalContactInfo } from "@esgt/types"
import { validateEmail } from "./index"

export function validateContactPerson(contributor: MinimalContactInfo): boolean {
  return contributor.name.length > 0 && validateEmail(contributor.email)
}
